export class CriteriaRatesFakeDb {
  public static rates = [];
}
